import { render } from "./Kp4Form.vue?vue&type=template&id=4e462e7e"
import script from "./Kp4Form.vue?vue&type=script&lang=js"
export * from "./Kp4Form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__